<div class="layout-auto-1">
	<div></div>
	<div class="content md3-surface">
	<div class="layout-list-quickfilter md3-card-on-surface">
		<exg-search-bar (Search)="serviceRecordTable.search($event)"
		                [placeholder]="getRessource('SearchHolder')"
		                class="span-layout">
			<ng-template #rightTemplate>
				<i (click)="serviceRecordTable.loadData()" class="search-action fal fa-sync"></i>
				<app-exg-dropdown>
					<ng-template #hostTemplate>
						<i class="search-action fa-filter"
						   [class.fas]="appSvc.metaInfo.uiFilterAktiv(serviceRecordTable.uiFilter, 1).length > 0"
						   [class.fal]="appSvc.metaInfo.uiFilterAktiv(serviceRecordTable.uiFilter, 1).length === 0"></i>
					</ng-template>
					<ng-template #contentTemplate let-popup>
						<app-exg-filter #VCserviceRecordTableFilterControl
						                (onActivateFilter)="serviceRecordTable.pageChanged(0);popup.close()"
						                [MetaInfo]="serviceRecordTable.MetaInfo"
						                [visibility]="popup.visibility !== 'hidden'"
						                [showFilter]="true" [uiFilter]="serviceRecordTable.uiFilter"
						                [uiSort]="serviceRecordTable.uiSort"></app-exg-filter>
					</ng-template>
				</app-exg-dropdown>
				<app-exg-dropdown>
					<ng-template #hostTemplate>
						<i class="search-action fa-sort-alt"
						   [class.fas]="appSvc.metaInfo.uiSortAktiv(serviceRecordTable.uiSort).length > 0"
						   [class.fal]="appSvc.metaInfo.uiSortAktiv(serviceRecordTable.uiSort).length === 0"></i>
					</ng-template>
					<ng-template #contentTemplate let-popup>
						<app-exg-filter #VCserviceRecordTableSortControl
						                (onActivateFilter)="serviceRecordTable.pageChanged(0);popup.close()"
						                [MetaInfo]="serviceRecordTable.MetaInfo"
						                [visibility]="popup.visibility !== 'hidden'"
						                [showSort]="true" [uiFilter]="serviceRecordTable.uiFilter"
						                [uiSort]="serviceRecordTable.uiSort"></app-exg-filter>
					</ng-template>
				</app-exg-dropdown>

        <app-exg-dropdown>
					<ng-template #hostTemplate>
						<i class="search-action fa-binoculars"
						   [class.fas]="appSvc.metaInfo.uiFilterAktiv(serviceRecordTable.uiFilter, 2).length > 0"
						   [class.fal]="appSvc.metaInfo.uiFilterAktiv(serviceRecordTable.uiFilter, 2).length === 0"></i>
					</ng-template>
					<ng-template #contentTemplate let-popup>
						<app-exg-filter #VCserviceRecordTableSearchControl
						                (onActivateFilter)="serviceRecordTable.pageChanged(0);popup.close()"
						                [MetaInfo]="serviceRecordTable.MetaInfo"
						                [visibility]="popup.visibility !== 'hidden'"
						                [showSearch]="true" [uiFilter]="serviceRecordTable.uiFilter"
						                [uiSort]="serviceRecordTable.uiSort"></app-exg-filter>
					</ng-template>
				</app-exg-dropdown>
			</ng-template>
		</exg-search-bar>

		<div class="content">
			<exg-data-table #VCserviceRecordTable
			                (RowChange)="serviceRecordTable.selectionChanged($event)"
			                (RowDblClick)="serviceRecordTable.dblClick($event)"
			                [allowSingleSelection]="true"
			                [displayState]="serviceRecordTable.state"
			                [rowSource]="serviceRecordTable.data"
			                containerClass="grid cols-14"
			                [selectKey]="serviceRecordTable.selectKey">
				<ng-template #headerTemplate>
					<div class="typo-small"
               [class.span-3]="!(selectedMod?.value === 'approved')"
               [class.span-2]="selectedMod?.value === 'approved'">
						<p><strong>{{getRessource('TableRenames.Record')}}</strong></p>
					</div>
					<div class="span-2 typo-small">
						<p><strong>{{getRessource('TableRenames.State')}}</strong></p>
					</div>
					<div class="span-2 typo-small">
						<p><strong>{{getRessource('TableRenames.Client')}}</strong></p>
					</div>
					<div class="typo-small"
               [class.span-3]="!(selectedMod?.value === 'approved')"
               [class.span-2]="selectedMod?.value === 'approved'">
						<p><strong>{{getRessource('TableRenames.Creator')}}</strong></p>
					</div>
					<div class="span-2 typo-small">
						<p><strong>{{getRessource('TableRenames.Created')}}</strong></p>
					</div>
					<div class="span-2 typo-small" *ngIf="selectedMod?.value === 'approved'">
						<p><strong>{{getRessource('TableRenames.Billing')}}</strong></p>
					</div>
					<div class="span-2 typo-small typo-right">
						<p><strong>{{getRessource('TableRenames.Total')}}</strong></p>
					</div>
				</ng-template>

				<ng-template #rowTemplate let-row>
					<div class="typo-small"
               [class.span-3]="!(selectedMod?.value === 'approved')"
               [class.span-2]="selectedMod?.value === 'approved'">
						<p><strong>{{row.leNr}}</strong></p>
						<p>{{row.leName}}</p>
					</div>
					<div class="span-2 typo-small">
						<span class="chip app-chip-status"
						      [ngClass]="getRessource('ServiceRecordStatusClass.' + row.leState)">{{getRessource('ServiceRecordStatus.' + row.leState)}}</span>
					</div>
					<div class="span-2 typo-small">
						<p>{{row.AuftraggeberShort}}</p>
					</div>
					<div class="typo-small"
               [class.span-3]="!(selectedMod?.value === 'approved')"
               [class.span-2]="selectedMod?.value === 'approved'">
						<p>{{row.leCRU}}</p>
					</div>
					<div class="span-2 typo-small">
						<p>{{row.leCRD | excDate: 'dd.MM.yyyy'}}</p>
					</div>
					<div class="span-2 typo-small" *ngIf="selectedMod?.value === 'approved'">
						<p *ngIf="row.leAbrechnungsMonat && row.leAbrechnungsJahr">
              {{row.leAbrechnungsMonat | number:'2.0'}}/{{row.leAbrechnungsJahr}}</p>

						<p *ngIf="!row.leAbrechnungsMonat || !row.leAbrechnungsJahr">
              {{getRessource('NoBillingDate')}}</p>
					</div>
					<div class="span-2 typo-small typo-right">
						<p><strong>{{sumTotal(row) | excCurrency: '€'}}</strong></p>
					</div>
				</ng-template>
			</exg-data-table>
		</div>
		<div class="search-quickfilter">
			<i class="search-filter-action fal fa-ban"
			   *ngIf="selectedMod?.value === 'active'"
			   (click)="cancelServiceRecord()"
			   [tooltip]="getRessource('cancelServiceRecord')" flow="left"
			   [class.disabled]="serviceRecordTable.isLoading || !serviceRecordTable.selectedRow">
			</i>
			<i class="search-filter-action fal fa-undo"
			   *ngIf="selectedMod?.value === 'canceled'"
			   (click)="restore()"
			   [tooltip]="getRessource('restoreServiceRecord')" flow="left"
			   [class.disabled]="serviceRecordTable.isLoading || !serviceRecordTable.selectedRow">
			</i>
			<i class="search-filter-action fal fa-chevron-right"
			   (click)="openCheckview()"
			   [tooltip]="getRessource('openCheckview')" flow="left"
			   [class.disabled]="serviceRecordTable.isLoading || !serviceRecordTable.selectedRow">
			</i>
		</div>
		<exg-pager class="span-layout" *ngIf="!init"
		           (PageChange)="serviceRecordTable.pageChanged($event)"
		           [pagingSource]="serviceRecordTable.paging">
			<ng-template #leftTemplate>
				<app-exg-dropdown class="typo-small"
                          [list]="preFilterDefinition"
                          elementclass="typo-left"
                          maxHeight="250px"
				                  [label]="selectedMod.caption"
                          position="abovecenter"
                          listdisplay="caption"
				                  (change)="changePreFilterMod($event.value)">
				</app-exg-dropdown>
			</ng-template>

			<ng-template #rightTemplate>
				<div class="app-pager-chips">
					<app-exg-filter-chips #VCFilterChips
					                      [inputDataTable]="serviceRecordTable"
					                      [VCFilterControl]="{ VCFilter: VCserviceRecordTableFilterControl,
                                                               VCSearch: VCserviceRecordTableSearchControl,
                                                               VCSort: VCserviceRecordTableSortControl}">
					</app-exg-filter-chips>
				</div>
			</ng-template>
		</exg-pager>
	</div>
</div>
</div>
